/* BeyTik - two small site-wide behaviours, loaded once from sections/bt-mobile-bar.liquid.
 *
 * 1. SOLD OUT LAST. Cards that are out of stock sink to the end of whatever
 *    list they are in: the collection grid, the hub carousels/grids that are
 *    not shuffled, and the Buy 2 Get 1 promo. (Shuffled hub carousels do this
 *    in bt-hub.js, because the sort has to happen BEFORE it decides which
 *    cards to show.) The sort is stable, so the shop's own ordering (best
 *    selling, price, ...) is untouched among in-stock items. It re-runs when
 *    cards are appended (bt-grid150.js loads pages 2 and 3 after the first)
 *    and when Dawn's filters swap the grid.
 *
 *    A collection is paged by Shopify, so "last" means last within what the
 *    browser has loaded, i.e. the 150 products on screen - not last across the
 *    whole collection.
 *
 *    The re-sort is debounced with setTimeout, not requestAnimationFrame: rAF
 *    does not fire in a background or hidden tab, which would leave the grid
 *    unsorted until the shopper came back to it.
 *
 * 2. BACK TO TOP. A round button that appears after scrolling and sits directly
 *    above the WhatsApp chat button (#chwhatsapp-btn, injected by the chat app,
 *    so its position is measured rather than assumed). No transition on
 *    bottom/opacity: the button just shows and hides.
 *
 *    THE MEASUREMENT USES clientWidth/clientHeight, NOT innerWidth/innerHeight.
 *    position:fixed offsets are relative to the viewport WITHOUT the scrollbar,
 *    and innerWidth includes it, so with a 15px desktop scrollbar the button sat
 *    15px left of the WhatsApp button instead of straight above it.
 */
(function () {
  'use strict';

  /* ---------- 1. sold out last ---------- */
  function sink(box, isOut) {
    var kids = [].slice.call(box.children), seenOut = false, sorted = true;
    kids.forEach(function (k) {
      if (isOut(k)) seenOut = true; else if (seenOut) sorted = false;
    });
    if (sorted) return;
    var live = [], sold = [];
    kids.forEach(function (k) { (isOut(k) ? sold : live).push(k); });
    var frag = document.createDocumentFragment();
    live.concat(sold).forEach(function (k) { frag.appendChild(k); });
    box.appendChild(frag);
  }
  function cardOut(el) { return !!el.querySelector('.bhpc--out'); }
  function promoOut(el) { return !!el.querySelector('button[disabled]'); }

  function sortAll() {
    var grid = document.getElementById('product-grid');
    if (grid) sink(grid, cardOut);
    [].forEach.call(document.querySelectorAll('.bt-hub-carousel:not([data-rand="true"]), .bt-hub-grid:not([data-rand="true"])'), function (b) { sink(b, cardOut); });
    [].forEach.call(document.querySelectorAll('[class^="bt-b2g1-prods-"], [class^="bt-b2g1-carousel-"]'), function (b) { sink(b, promoOut); });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; sortAll(); }, 30);
  }

  function watch() {
    sortAll();
    var box = document.getElementById('ProductGridContainer');
    if (box) new MutationObserver(queue).observe(box, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('shopify:section:load', queue);

  /* ---------- 2. back to top ---------- */
  var SIZE = 44, GAP = 16;
  var css = '.bt-top{position:fixed;right:16px;bottom:150px;z-index:9990;width:' + SIZE + 'px;height:' + SIZE + 'px;border-radius:50%;border:0;padding:0;' +
    'background:var(--btm-ac,#4999bb);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;' +
    'box-shadow:0 8px 20px -6px rgba(15,23,42,.55);-webkit-tap-highlight-color:transparent}' +
    '.bt-top[hidden]{display:none}.bt-top:active{transform:scale(.92)}.bt-top svg{width:20px;height:20px}';

  function mountTop() {
    if (document.querySelector('.bt-top')) return;
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bt-top';
    b.hidden = true;
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(b);

    function place() {
      var de = document.documentElement;
      var wa = document.getElementById('chwhatsapp-btn');
      var r = wa && wa.getBoundingClientRect();
      if (r && r.width && r.top > 0) {
        var cx = r.left + r.width / 2;
        b.style.bottom = Math.round(de.clientHeight - r.top + GAP) + 'px';
        b.style.right = Math.max(6, Math.round(de.clientWidth - cx - SIZE / 2)) + 'px';
      } else {
        b.style.bottom = (window.innerWidth < 1025 ? 160 : 100) + 'px';
      }
    }
    var tick = false;
    function update() {
      tick = false;
      var show = (window.pageYOffset || document.documentElement.scrollTop) > 500;
      if (b.hidden === show) b.hidden = !show;
      if (show) place();
    }
    function req() { if (!tick) { tick = true; setTimeout(update, 16); } }
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountTop); else mountTop();
})();